import * as errorMessages from "./errorMessages";
import * as validate from "./validate";
import checkDeviceOnResize from "./watchScreenWidth";

export { checkDeviceOnResize, errorMessages, validate };



// WEBPACK FOOTER //
// ./src/util/index.js